import VueI18n from "vue-i18n";
import {en, he, ar} from "./lang";
import Vue from "vue";

Vue.use(VueI18n);

function getSystemLang() {
	return localStorage.getItem("lang") || document.documentElement.lang || "he";
}
const rtlLanguages = ["he", "ar"]; // Add all RTL languages here

export function isRtl(lang = i18n.locale) {
	return rtlLanguages.includes(lang);
}

export const i18n = new VueI18n({
	locale: getSystemLang(),
	fallbackLocale: "he",
	messages: {
		he,
		en,
		ar
	}, // set locale messages
});

export function setLang(lang) {
	localStorage.setItem("lang", lang);
	document.documentElement.lang = lang;
	if (i18n.locale !== lang) {
		i18n.locale = lang;
		// reload the page with new language param
		// tell the server the language change
		const url = new URL(window.location.href);
		url.searchParams.set("lang", i18n.locale);
		location.href = url.toString();
	}
}

export default i18n;
